import { PeriodDto } from '@core/mappers/offer/dtos/PeriodDto';
import { Period } from '@core/models/offer/Period';

export function transformPeriod(dto: PeriodDto): Period {
    return {
        team1Score: parseInt(dto.homeTeamScore, 10),
        team2Score: parseInt(dto.awayTeamScore, 10),
        type: dto.type,
        number: dto.num,
        score: `${dto.homeTeamScore}:${dto.awayTeamScore}`,
    };
}
